<template>
  <div>
    <b-navbar style="margin-top: 50px;" type="is-warning">
      <template slot="start">
        <b-navbar-item @click="() => setPage('deals')" :active="page === 'deals'">Deals</b-navbar-item>
        <b-navbar-item
          @click="() => setPage('pending_users')"
          :active="page === 'pending_users'"
        >Pending Users</b-navbar-item>
        <b-navbar-item
          @click="() => setPage('active_users')"
          :active="page === 'active_users'"
        >Active Users</b-navbar-item>
      </template>
    </b-navbar>
    <div class="columns" style="margin: 5px; margin-top: 20px;">
      <div class="column" style="overflow:auto;">
        <AdminDeals v-if="page === 'deals'" />
        <AdminUsersPending v-if="page === 'pending_users'" />
        <AdminUsersActive v-if="page === 'active_users'" />
      </div>
    </div>
  </div>
</template>

<script>
import AdminDeals from "./AdminDeals.vue";
import AdminUsersPending from "./AdminUsersPending.vue";
import AdminUsersActive from "./AdminUsersActive.vue";

export default {
  name: "Admin",
  data() {
    return {
      page: "deals"
    };
  },
  components: {
    AdminDeals,
    AdminUsersPending,
    AdminUsersActive
  },
  methods: {
    setPage: function(page) {
      this.page = page;
    }
  }
};
</script>
